export default __webpack_public_path__ + "static-front/media/FiltersIcon.6581babc.svg";